import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { applyBreakpoints } from '../../utils/breakpoints';
import { mapStateToProps } from '../../utils/mapper';
import { button, colors } from '../../utils/styles';

import * as ReactGA from '../../modules/google_analytics';
import { openUrl } from '../../modules/links';
import { Redirect } from '../../modules/routing';

import Action from '../../modules/svgs/action';

interface ButtonLinkProps {
  text: string;
  destination?: string;
  onPress?: () => void;
  dark?: boolean;
  window: Window;
  disabled?: boolean;
  noMin?: boolean;
  results?: boolean;
  external?: boolean;
  small?: boolean;
  test?: boolean;
}

const styles = (multiplier) => ({
  button: RX.Styles.createViewStyle({
    borderRadius: 5 * multiplier,
    height: 40 * multiplier,
    marginVertical: 12 * multiplier,
    minWidth: 200 * multiplier,
    padding: 12 * multiplier,
  }),
  buttonText: RX.Styles.createTextStyle({
    color: colors.white,
    letterSpacing: 0.4,
    textAlign: 'center',
    textDecorationLine: 'none',
  }),
});

export class ButtonLink extends RX.Component<ButtonLinkProps, RX.CommonProps & { showRedirect: boolean }> {

  constructor(props: ButtonLinkProps) {
    super(props);
    this.state = { showRedirect: false };
    this.redirect = this.redirect.bind(this);
  }

  public render() {
    const { dark, disabled, destination = '', external, test, onPress,
      text, window: { width, multiplier = 1 }} = this.props;

    if (!test && this.state.showRedirect) {
      return <Redirect to={destination} />
    }

    return (
      <RX.Button
        disabled={disabled}
        style={[
          styles(multiplier).button,
          { height: RX.Platform.getType() === 'web' ? 60 * multiplier : 50, minWidth: 0 },
          { backgroundColor: disabled ? colors.grey : dark ? colors.secondary : colors.primary },
          this.props.small ? { maxWidth: 200 * multiplier } : { maxWidth: width },
          ...applyBreakpoints(width,
            {
              md: {
                maxWidth: this.props.results ? 150 : 270,
                minWidth: this.props.results ? 136 : 150,
              }
            })
        ]}
        onPress={() => {
          destination && ReactGA.trackEvent(
            'Open new tab',
            'Outbound',
            { label: destination }
          ); //tslint:disable-line
          onPress && !disabled && onPress(); //tslint:disable-line
          { destination && (!test && external ? openUrl(destination, '_blank') : openUrl(destination, '_self')) } //tslint:disable-line
        }}
      >
        <RX.Text style={[button(multiplier), styles(multiplier).buttonText, { fontSize: 18 * multiplier}]}>
          {text}
        </RX.Text>
      </RX.Button>
    );
  }

  private redirect() {
    this.setState({ showRedirect: true });
  }
}

export default connect(mapStateToProps)(ButtonLink);



// WEBPACK FOOTER //
// ./src/components/button_link/index.tsx